import { KV } from '../common/Constant.js';
import qs from 'querystringify';
import { urljoin } from '../utils/utils';
export default class Http {
  constructor(store) {
    this.store = store;
    this.eventHandler = {
      onError: this._onError.bind(this),
      onTimeOut: this._onTimeout.bind(this),
      onLoad: this._onLoad.bind(this),
      onLoadend: this._onLoadend.bind(this)
    };
    this.xmlhttp = new XMLHttpRequest();

    try {
      this.xmlhttp.timeout = 15000; // 请求最大时间
      this.xmlhttp.responseType = 'json';
    } catch (orz) {
      /**/
    }
    this.xmlhttp.onload = this.eventHandler.onLoad;
    this.xmlhttp.ontimeout = this.eventHandler.onTimeOut;
    this.xmlhttp.onerror = this.eventHandler.onError;
    this.xmlhttp.onloadend = this.eventHandler.onLoadend;

    this.onError = null;
    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
  }

  _onError(e) {
    this.onError && this.onError((e.target && e.target.response) || new Error('网络错误'));
    this.onError = null;
  }

  _onLoad(e) {
    if (!e.target) {
      this._onError(e);
      return;
    }
    let response = e.target.response;
    if (typeof response === 'string' && response[0] === '{') {
      try {
        response = JSON.parse(response);
      } catch (e) {
        /**/
      }
    }

    const { code, data, msg } = response;
    e.message = msg;
    e.msg = msg;
    if (+code !== 200) {
      this._onError(e);
      return;
    }

    this.onLoad && this.onLoad(data);
    this.onLoad = null;
  }

  _onLoadend(e) {
    this.onLoadend && this.onLoadend(e.target);
    this.onLoadend = null;
  }

  _onTimeout(e) {
    this.onTimeout && this.onTimeout(e.target);
    this.onTimeout = null;
  }

  request(apiUrl = '', data = {}, method = 'POST') {
    if (!this.xmlhttp) return;

    let url = apiUrl.slice(0, 4).toLocaleLowerCase() === 'http' ? apiUrl : urljoin(process.env.API_SERVER, apiUrl);

    const formdata = new FormData();
    formdata.set(KV.APP_ID, this.store.getKV(KV.APP_ID));
    formdata.set(KV.CLIENT, this.store.getKV(KV.CLIENT));
    formdata.set(KV.ACCESS_TOKEN, this.store.getKV(KV.ACCESS_TOKEN));
    formdata.set(KV.THIRD_PARTY_USER_ID, this.store.getKV(KV.THIRD_PARTY_USER_ID));
    formdata.set(KV.PACKAGE_CHECK, this.store.getKV(KV.PACKAGE_CHECK));
    Object.keys(data).forEach(key => {
      formdata.set(key, data[key]);
    });

    data[KV.CLIENT] = this.store.getKV(KV.CLIENT);
    data[KV.APP_ID] = this.store.getKV(KV.APP_ID);
    data[KV.THIRD_PARTY_USER_ID] = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    data[KV.ACCESS_TOKEN] = this.store.getKV(KV.ACCESS_TOKEN);
    data[KV.PACKAGE_CHECK] = this.store.getKV(KV.PACKAGE_CHECK);

    switch (method) {
      case 'POST':
        this.xmlhttp.open(method, url);
        this.xmlhttp.send(formdata);
        break;
      case 'GET':
        url += qs.stringify(data, true);
        this.xmlhttp.open(method, url);
        this.xmlhttp.send();
        break;
      default:
        break;
    }
  }

  destroy() {
    if (!this.xmlhttp) {
      return;
    }

    this.xmlhttp.onerror = null;
    this.xmlhttp.onload = null;
    this.xmlhttp.onloadend = null;
    this.xmlhttp.ontimeout = null;
    this.xmlhttp = null;

    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
    this.onError = null;
  }
}
